export default __webpack_public_path__ + "static/media/trash-fill.bec657fd.svg";